import Vue from 'vue'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)



// WEBPACK FOOTER //
// ./src/front/init/utils/cookies.js